import { Collapse, CollapseProps } from 'antd';
import classNames from 'classnames';
import { ReactNode } from 'react';

import { Icon } from '../Icon/Icon';

import './Accordion.scss';

interface Props extends CollapseProps {
  variant?: 'grey' | 'transparent';
}

// @ts-ignore
export type AccordionData = CollapseProps['items'][number];

const getCustomItems = (items: AccordionData[]): AccordionData[] => {
  return items.map((item) => ({
    ...item,
    className: classNames(item.className, 'custom-accordion-item'),
  }));
};

export const Accordion: React.FC<Props> = ({ className, items, accordion = true, variant = 'grey', ...props }) => {
  return (
    <Collapse
      data-testid="accordion"
      {...props}
      accordion={accordion}
      expandIconPosition="end"
      className={classNames('custom-accordion', `custom-accordion--${variant}`, className)}
      items={getCustomItems(items ?? [])}
      expandIcon={(): ReactNode => <Icon className="custom-accordion-icon" name="chevron_down" />}
    />
  );
};
